import {
  GET_FOOTER_PAGE_FAILED,
  GET_FOOTER_PAGE_MOBILESIDE_FAILED,
  GET_FOOTER_PAGE_MOBILESIDE_REQUEST,
  GET_FOOTER_PAGE_MOBILESIDE_SUCCESS,
  GET_FOOTER_PAGE_REQUEST,
  GET_FOOTER_PAGE_SUCCESS,
  UPDATE_FOOTER_PAGE_FAILED,
  UPDATE_FOOTER_PAGE_REQUEST,
  UPDATE_FOOTER_PAGE_SUCCESS,
  FAQ_CREATE_FAILED,
  FAQ_CREATE_SUCCESS,
  FAQ_CREATE_REQUEST,
  FAQ_REMOVE_SUCCESS,
  FAQ_REMOVE_FAILED,
  FAQ_REMOVE_REQUEST,
} from "../Actions/FooterPageAction";

const FooterPageInitialState = {
  loading: false,
  success: false,
  errors: {},
  FooterPageMobileData: [],
  FAQ: [{}],
  FooterData: {},
};

export const FooterPageReducer = (state = FooterPageInitialState, action) => {
  switch (action.type) {
    case UPDATE_FOOTER_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_FOOTER_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        FooterPageData: action?.payload,
      };
    case UPDATE_FOOTER_PAGE_FAILED:
      return {
        ...state,
        loading: false,
      };

    case FAQ_CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FAQ_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        FAQ: action.payload,
      };
    case FAQ_CREATE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case FAQ_REMOVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FAQ_REMOVE_SUCCESS:
      return {
        ...state,
        loading: false,
        FAQ: state.FAQ.filter((item) => action.payload !== item.id),
      };
    case FAQ_REMOVE_FAILED:
      return {
        ...state,
        loading: false,
      };

    case GET_FOOTER_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FOOTER_PAGE_SUCCESS:
      let { tab } = action.payload; 
      let data  = action.payload.decryptData      
      return {
        ...state,
        FooterData:
          tab === "PRIVACYPOLICY"
            ? data.PRIVACY_POLICY
            : tab === "TERMS&CONDITIONS"
            ? data.TERMS_CONDITIONS
            : tab === "COOKIEPOLICY"
            ? data.COOKIE_POLICY
            : "",
        loading: false,
        FAQ: tab === "FAQ" ? data.FAQ : [{}],
      };
    case GET_FOOTER_PAGE_FAILED:
      return {
        ...state,
        loading: false,
      };

    case GET_FOOTER_PAGE_MOBILESIDE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FOOTER_PAGE_MOBILESIDE_SUCCESS:
      return {
        ...state,
        loading: false,
        FooterPageMobileData: action?.payload,
      };
    case GET_FOOTER_PAGE_MOBILESIDE_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
